// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__1Av7t","pencil":"IconEdit_pencil__10CdC"};